import ClientDetails from './ClientDetails'

export default ClientDetails
